import { TerminalModel } from "model/Terminal.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = TerminalModel[];

export const useDefaultObservableTerminalModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectTerminalModelArray extends BehaviorSubject<CurrentType> {}
